<template>
  <div>
    <a-dropdown class="action-item" placement="bottomRight">
      <div class="user-info">
        <iconfont iconClass="user" iconSize="24" v-if="!userInfo"></iconfont>
        <a-avatar :src="userInfo.avatar" :size="24" v-else class="avatar-bg">{{ userInfo.nickname }}</a-avatar>
      </div>
      <a-menu slot="overlay" class="middle-menu" :selectable="false">
        <a-menu-item>
          <span class="name" v-if="userInfo">{{ userInfo.nickname }}</span>
        </a-menu-item>
        <a-menu-item key="setting">
          <router-link to="/systemSetting/baseInfo">
            <a-icon type="user"></a-icon>
            个人主页</router-link
          >
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item key="logout">
          <a href="javascript:;" @click="logout">
            <a-icon type="logout"></a-icon>
            退出登录</a
          >
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { logout } from '@/api/user';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    logout() {
      logout().then(res => {
        if (res.code === 200) {
          this.$store.dispatch('user/SET_LOGOUT');
          localStorage.removeItem('loginHistory');
          this.$router.push('/login');
        }
      });
    }
  }
};
</script>

<style lang="less">
.user-info img {
  width: 24px;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: middle;
}
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader img {
  width: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
